<div fxLayout="column" fxLayoutGap="20px">
  <div
    *ngIf="showDeliveryPrice"
    fxLayout="row"
    fxLayoutAlign="space-between start"
  >
    <h3 class="rm-margin">
      {{ "DELIVERY_METHOD" | translate }}
    </h3>
    <h3 class="rm-margin">{{ shippingPrice | euro }}</h3>
  </div>

  <div *ngIf="showFormFee" fxLayout="row" fxLayoutAlign="space-between start">
    <h3 class="rm-margin">
      {{ "FORM_FEE" | translate }}
    </h3>
    <h3 class="rm-margin">{{ formFee | euro }}</h3>
  </div>

  <div *ngIf="showVaultSubsCost" fxLayout="row" fxLayoutAlign="space-between start">
    <h3 class="rm-margin">
      {{ "VAULT_SUBSCRIPTION_COST" | translate }}
    </h3>
    <h3 class="rm-margin">{{ vaultSubsCost | euro }}</h3>
  </div>

  <div *ngIf="showTaxPrice" fxLayout="row" fxLayoutAlign="space-between start">
    <h3 class="rm-margin">
      {{ "TAX" | translate }}
    </h3>
    <h3 class="rm-margin">{{ taxPrice | euro }}</h3>
  </div>

  <span class="yellow-line"></span>

  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
    <span>{{ "TOTAL_PRICE" | translate }}</span>
    <span *ngIf="taxIncludes">{{ "TAX_INCLUDES" | translate }}</span>
    <span fxFlex></span>
    <span>{{ totalPrice | number: "1.2-2" | euro }} </span>
  </div>
</div>
